import { ExtEntityRegistryEntry } from "@hakit/core";

export function DummyComponentReturn(props: Partial<ExtEntityRegistryEntry>) {
  return props;
}
